import { createServerFn } from '@tanstack/react-start'
import { generateSlugWithDate } from '../shared/crudFactory'
import { getFromS3, putToS3 } from '../../lib/s3'
import { createStickerSchema } from './stickerSchemas'
import type { Sticker } from './stickerSchemas'

/**
 * Create a new sticker
 */
export const createSticker = createServerFn({ method: 'POST' })
  .inputValidator(createStickerSchema)
  .handler(async (ctx): Promise<{ success: boolean; id: string }> => {
    const data = ctx.data

    // Generate ID from sticker name with date suffix
    const id = generateSlugWithDate(data.name)

    const sticker: Sticker = {
      id,
      name: data.name.trim(),
      phrase: data.phrase.trim(),
      rows: data.rows,
      columns: data.columns,
      textSize: data.textSize,
      padding: data.padding,
      textColor: data.textColor,
      bgColor: data.bgColor,
      fontFamily: data.fontFamily,
      wrapText: data.wrapText,
    }

    try {
      // Check if sticker already exists
      try {
        await getFromS3(`stickers/${id}.json`)
        throw new Error(`Sticker with id '${id}' already exists`)
      } catch (e: any) {
        if (e.name !== 'NoSuchKey' && !e.message.includes('already exists')) {
          throw e
        }
      }

      await putToS3(`stickers/${id}.json`, sticker)
      return { success: true, id }
    } catch (error: any) {
      throw new Error(error.message || 'Failed to create Sticker')
    }
  })
